import React, { createContext, useCallback, useEffect, useReducer } from 'react';
import { defaultState, reducers } from './reducers';
import { Actions, UseOverlayState } from './types';

export const OverlayContext = createContext<any>([]);

export const OverlayProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer<React.Reducer<UseOverlayState, Actions>>(
    reducers,
    defaultState()
  );

  const setShowOverlay = useCallback(
    (showOverlay: boolean) => {
      dispatch({ type: 'SET_SHOW_OVERLAY', payload: { showOverlay } });
    },
    [state]
  );

  return (
    <OverlayContext.Provider value={[state, { setShowOverlay }]}>
      {children}
    </OverlayContext.Provider>
  );
};

export default OverlayProvider;
